var render, staticRenderFns
import script from "./BidConfirmation.vue?vue&type=script&lang=js&"
export * from "./BidConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./BidConfirmation.vue?vue&type=style&index=0&id=66f1d22a&scoped=true&lang=scss&"
import style1 from "./BidConfirmation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1d22a",
  null
  
)

export default component.exports